module.exports = __webpack_public_path__ + "img/springhill-logo.07227592.jpg";